module.exports = __webpack_public_path__ + "img/Componente 43 – 1.c0e4f3d3.svg";